import { TextFieldDemo, TextFieldFilledTextAreaDemo, TextFieldOutlineDemo, TextFieldOutlinedTextAreaDemo } from "..\\..\\..\\..\\src\\demos\\text-field-demo";
import React from 'react';
export default {
  TextFieldDemo,
  TextFieldFilledTextAreaDemo,
  TextFieldOutlineDemo,
  TextFieldOutlinedTextAreaDemo,
  React
};